"use client";
import { FC, useContext } from "react";
import { IndexCardsContext } from "./IndexContextBlock";
import { HorizontalFilter } from "@/components/HorizontalFilter";
import { BuilderBlockProps } from "@/types";
import { TreeNode } from "@/types/General";
type HorizontalFilterBlockProps = {
  configuration: {
    parameterName: string;
    placeholder?: string;
    multiple?: boolean;
    selectAllText?: string;
  }[];
} & BuilderBlockProps;
export const HorizontalFilterBlock: FC<HorizontalFilterBlockProps> = ({
  configuration,
  attributes,
}) => {
  const { selectedFilters, onFilter, filters } = useContext(IndexCardsContext);

  return (
    <HorizontalFilter
      selectedFilters={selectedFilters}
      onFilter={onFilter}
      filters={
        configuration?.reduce(
          (
            acc,
            currentValue,
          ): {
            label: string;
            name: string;
            placeholder?: string;
            categories: TreeNode[];
            multiple?: boolean;
            selectAllText?: string;
          }[] => {
            const filter = filters.find(
              ({ name }) => name === currentValue.parameterName,
            );
            if (filter) {
              return [
                ...acc,
                {
                  ...filter,
                  placeholder: currentValue.placeholder,
                  multiple: currentValue.multiple,
                  selectAllText: currentValue.selectAllText,
                },
              ];
            }

            return acc;
          },
          [],
        ) ?? filters
      }
      {...attributes}
    />
  );
};
